import {Injectable} from '@angular/core';
import {RouterHelperService} from 'app/core/services/router-helper.service';
import {Subscription} from 'rxjs';
import {skip} from 'rxjs/operators';

declare const ga;

interface GoogleOptimize {
    get(experimentKey: string): string | undefined;
}

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    ga =
        typeof ga !== 'undefined'
            ? ga
            : function () {
                  console.debug('[GoogleAnalytics]', ...arguments);
              };

    sub = Subscription.EMPTY;

    constructor(private routerHelper: RouterHelperService) {}

    init() {
        this.sub.unsubscribe();
        this.sub = this.routerHelper.routeChanges$
            // first init will be in analytics.js
            // that's why we should skip first event here
            .pipe(skip(1))
            .subscribe(() => {
                this.ga('set', 'page', document.location.pathname + document.location.search);
                this.ga('send', 'pageview');
            });
    }

    sendEvent(actionName: string): void {
        this.ga('send', 'event', 'action', actionName);
    }

    get optimize(): GoogleOptimize {
        // @ts-ignore
        return window.google_optimize
            ? // @ts-ignore
              window.google_optimize
            : {
                  get: (experimentKey: string) => {
                      console.debug([`[GoogleOptimize] get(${experimentKey})`]);
                      return undefined;
                  },
              };
    }
}
